export const CConfettiAnimation = "./assets/animations/Confetti.json"